import { useQuery } from '@tanstack/react-query';
import { IAccountSnapshot } from '../../../models/AdminModels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { IAccountFilterCriteria } from '../../../viewmodels/AdminViewModels';
import { reactQueryClient } from '../../../web/ReactQueryProvider';

const BASE_KEY = `admin/accountsnapshot/byMonth`;

export function useAdminAccountSnapshotByMonthQuery({ filter }: { filter: IAccountFilterCriteria }) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: [BASE_KEY, filter],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IAccountSnapshot[]>(`admin/accountsnapshot/byMonth`, 'POST', filter),
	});
}

export const invalidateAdminAccountSnapshotByMonthQuery = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_KEY] });
};
